export const noEl = document.createElement('marquee');
